<button
  itemCartTarget
  itemCartTargetId="basket"
  fastTooltip="Selected Deals"
  (click)="toggle()"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  semerisIconButton
  color="accent">
  <mat-icon [matBadge]="deals()?.length" matBadgeColor="warn" aria-hidden="false"
    >shopping_cart</mat-icon
  >
</button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayPanelClass]="[
    'semeris-overlay',
    'semeris-overlay-xl',
    'deals-indicator-overlay',
  ]"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'overlay-transparent'"
  (backdropClick)="toggle()">
  <div class="semeris-overlay-container mat-elevation-z4 deals-indicator-overlay-contaienr">
    <div class="selected-deals-title">
      <h3>Selected Deals</h3>
      <semeris-help-icon helpId="selected-deals.html"></semeris-help-icon>
    </div>

    <mat-divider></mat-divider>
    @if (!deals().length) {
      <span class="semeris-overlay-placeholder"
        >Deals you select here will top your market comparisons and other lists. Use the + by deal
        names to add them here.
        <ng-container *ifAsset="'euclo'">
          See an
          <a (click)="addExample()">example</a>
        </ng-container>
      </span>
    } @else {
      <ul class="semeris-overlay-list">
        @for (deal of deals(); track deal.transactionDisplayShortName) {
          <li (click)="toggle()">
            <div class="semeris-overlay-item">
              <a class="text-truncate" [routerLink]="deal | transactionToLink">
                <span class="deal-name text-truncate">
                  <semeris-traffic-light
                    [text]="deal.transactionDisplayName"
                    [quality]="deal.qualityTrafficLight"></semeris-traffic-light>
                  @if (deal.private) {
                    <mat-icon
                      fastTooltip="Private deal - Visible in your organization only"
                      class="private-deal-icon"
                      >lock</mat-icon
                    >
                  }
                  @if (deal.autoPublished) {
                    <mat-icon
                      fastTooltip="Auto Published"
                      class="auto-published-icon"
                      >flash_auto</mat-icon
                    >
                  }
                  @if (deal?.mostRecentIssue) {
                    <semeris-latest-issuance
                      mode="icon"
                      [transaction]="deal?.mostRecentIssue"
                      (clicked)="toggle()"></semeris-latest-issuance>
                  }
                  <semeris-labels [labels]="[deal?.libraryLabel]"></semeris-labels>
                </span>
                <button
                  semerisIconButton
                  color="accent"
                  [disabled]="loading()"
                  (click)="onRemoveFromSelection(deal.transactionId, $event)"
                  fastTooltip="Remove from selection">
                  <mat-icon>remove</mat-icon>
                </button>
              </a>
            </div>
          </li>
        }
      </ul>
      <mat-divider></mat-divider>
      <div class="semeris-overlay-operations">
        <button class="btn-gray" semerisButton (click)="onClear()" aria-label="Unselect all">
          Unselect all
        </button>
        <div>
          <button
            semerisButton
            color="accent"
            (click)="toggle()"
            [routerLink]="['/', SemerisRoutes.dealFilter.root, SemerisRoutes.dealFilter.filter]"
            [queryParams]="{
              transactions: transactionNames,
              defaultFilters: false,
              displayName: displayName,
            }"
            aria-label="Convert to Deal Filter">
            Convert to Deal Filter
          </button>
          <button
            *permissions="[Permission.READ_DEAL_COMPARE]"
            semerisButton
            color="accent"
            (click)="toggle()"
            [routerLink]="[
              '/',
              SemerisRoutes.transactions.root,
              SemerisRoutes.transactions.compare,
            ]"
            [queryParams]="{ mode: dealFilterMode }"
            aria-label="Deal Compare">
            Deal Compare
          </button>
          <button
            *permissions="[Permission.READ_MARKET_COMPARE]"
            semerisButton
            color="accent"
            (click)="toggle()"
            [routerLink]="['/', SemerisRoutes.marketComparison.root]"
            [queryParams]="undefined | columnsToLink"
            aria-label="Market Compare">
            Market Compare
          </button>
        </div>
      </div>
    }
  </div>
</ng-template>
